module.exports = __webpack_public_path__ + "media/images/svg/hush-logo-with-circle-a5f18aa3f83a5ae6bdeb004120c00761.svg";